namespace TR {

    class HolidayDealsPromoService {
        DEST_IMGS: any;
        ALL_IMGS: any;
        MONTH: any;

        constructor(
            private $q: ng.IQService,
            private $filter: any,
            private $location: any,
            private holidayDeals: HolidayDeals,
            private destinationService: any,
            private analytics: any,
            private filtering: Filtering,
            private occupancyService: any,
            private resourceService: Core.ResourceService,
            private dateUtil: any,
            private currencyService: any
        ) {
            this.DEST_IMGS =
                `https://d2f0rb8pddf3ug.cloudfront.net/api2/destination/images/getfromobject`;
            this.ALL_IMGS =
                `https://s3-eu-west-1.amazonaws.com/trp-content/.co.uk/web`;
        }

        getInfoPromo() {
            let params;
            return this.holidayDeals.getFullParameters(true, { startDate: this._getNextMonth() })
                .then(p => {
                    params = p;
                    return _.head(p.depAir);
                })
                .then(this.destinationService.getAirport)
                .then(airport => {
                    const plus = _.size(params.depAir) > 1 ? ` (+${_.size(params.depAir)})` : '';
                    return {
                        summary: {
                            occupancy: this._buildOccupancyString(params.occupancy),
                            month: this.$filter('date')(params.startDate, 'MMMM yyyy'),
                            duration: params.duration,
                            airport: `${airport.Title}${plus}`,
                        },
                        blocks: this._getBlocks(params.duration)
                    };
                });
        }

        _getBlocks(duration: number) {
            const num = this.occupancyService.getNumberOfNonInfantPassengers() * duration;
            let [min, mid, high] = _.map(
                TRPCONFIG.Domain.HolidayDealsPromoPrices || [',50', '50,95', '95,'],
                (p:string) => _(p)
                    .split(',')
                    .map((x:string) => (x ? parseInt(x, 10) : 0) * num)
                    .value()
            );

            const cSymbol = this.currencyService.getSymbol(TRPCONFIG.Domain.CurrencyCode);
            this._adjustPriceRange(min, mid, high);
            return {
                budget: [
                    {
                        label: 'HOLIDAYDEALSPROMOSHOW',
                        img: `${this.ALL_IMGS}/promo_everything.png`,
                        name: 'PriceRange',
                        value: null,
                        group: 'budget'
                    },
                    {
                        label: String.format(this.resourceService.get('UPTOX'), `${cSymbol}${min[1]}`),
                        img: `${this.ALL_IMGS}/promo_low_budget.png`,
                        name: 'PriceRange',
                        value: `${min[0] || ''},${min[1] || ''}`,
                        group: 'budget',
                        type: 'low'
                    },
                    {
                        label:
                            `${cSymbol}${mid[0]} - ${cSymbol}${mid[1]}`,
                        img: `${this.ALL_IMGS}/promo_mid_budget.png`,
                        name: 'PriceRange',
                        value: `${mid[0] || ''},${mid[1] || ''}`,
                        group: 'budget',
                        type: 'mid'
                    },
                    {
                        label: ` ${cSymbol}${high[0]}+`,
                        img: `${this.ALL_IMGS}/promo_high_budget.png`,
                        name: 'PriceRange',
                        value: `${high[0] || ''},${high[1] || ''}`,
                        group: 'budget',
                        type: 'high'
                    }
                ],

                type: [
                    {
                        label: 'SEO_BEACH',
                        img: `${this.ALL_IMGS}/promo_beach.png`,
                        name: 'FacilityCodes',
                        value: 'HB',
                        group: 'type'
                    },
                    {
                        label: 'DEALSCITYROUTENAME',
                        img: `${this.ALL_IMGS}/promo_city.png`,
                        name: 'FacilityCodes',
                        value: 'HT',
                        group: 'type'
                    },
                    TRPCONFIG.Domain.HolidayDealsCruisesEnabled
                    ? {
                        label: 'MENUCRUISE',
                        img: `${this.ALL_IMGS}/promo_cruise.png`,
                        name: 'PropertyTypes',
                        value: '5',
                        group: 'type'
                    }
                    : {
                        label: 'FAMILY',
                        img: `${this.ALL_IMGS}/promo_family.png`,
                        name: 'FacilityCodes',
                        value: 'HF',
                        group: 'type'
                    },
                    {
                        label: 'LANDINGPAGEATTRACTIONSACTIVITIES_NIGHTLIFE',
                        img: `${this.ALL_IMGS}/promo_nightlife.png`,
                        name: 'FacilityCodes',
                        value: 'HN',
                        group: 'type'
                    },
                    {
                        label: 'SPARELAXATION',
                        img: `${this.ALL_IMGS}/promo_spa.png`,
                        name: 'FacilityCodes',
                        value: 'SP',
                        group: 'type'
                    },
                    {
                        label: 'ROMANTIC',
                        img: `${this.ALL_IMGS}/promo_romantic.png`,
                        name: 'FacilityCodes',
                        value: 'HC',
                        group: 'type'
                    },
                    {
                        label: 'ACTIVITY',
                        img: `${this.ALL_IMGS}/promo_activity.png`,
                        name: 'FacilityCodes',
                        value: 'HA',
                        group: 'type'
                    },
                    {
                        label: 'FARAWAY',
                        img: `${this.ALL_IMGS}/promo_far_away.png`,
                        name: 'ChildDestinations',
                        value: TRPCONFIG.Domain.HolidayDealsPromoDestinations,
                        group: 'type'
                    },
                ]
            };
        }

        _buildOccupancyString(occ) : string {
            const o:any = _.first(occ);
            const childNum = _.size(occ.ChildAges);
            const adults = `${o.Adults} ${this.resourceService.get(o.Adults === 1 ? 'ADULT' : 'ADULTS')}`;
            const children = `${childNum} ${this.resourceService.get(childNum === 1 ? 'CHILD' : 'CHILDREN')}`;
            return childNum === 0 ? adults : `${adults} ${children}`;
        }

        _adjustPriceRange(min, mid, high) {
            const priceRange = _.get<string>(this.$location.search(), 'PriceRange');
            if (!priceRange) { return; }
            const newPriceRange = _.startsWith(priceRange, ',') ? min : _.endsWith(priceRange, ',') ? high : mid;
            this.$location.search('PriceRange', `${newPriceRange[0] || ''},${newPriceRange[1] || ''}`);
        }

        _getNextMonth(): Date {
            const today = new Date();
            let month = today.getMonth();
            const year = month === 11 ? today.getFullYear() + 1 : today.getFullYear();
            month = month === 11 ? 0 : month + 1;
            return new Date(year, month, 15, 0, 0, 0, 0);
        }
    }

    angular
        .module('TR')
        .service('holidayDealsPromoService', HolidayDealsPromoService);
}
